import {t} from '@lingui/core/macro';

import {PALETTE} from 'shared/config/model/palette';

import {ServerStatus} from '../model/Server/IServer';

export function getServerStatusLabel(status: ServerStatus): string {
    switch (status) {
        case 'pending':
            return t`Ожидание данных`;
        case 'online':
            return t`Онлайн`;
        case 'offline':
            return t`Оффлайн`;
        case 'paused':
            return t`На паузе`;
        case 'suspended':
            return t`Отключён по тарифу`;
        default:
            return status;
    }
}

export const isServerPaused = (status: ServerStatus): boolean => status === 'paused' || status === 'suspended';

export const colorServerStatus = (status: ServerStatus): string => {
    const map: Record<ServerStatus, string> = {
        online: PALETTE.success,
        offline: PALETTE.error,
        suspended: PALETTE.warning,
        pending: PALETTE.neutralMuted,
        paused: PALETTE.neutralMuted,
    };

    return map[status];
};
